import styled from 'styled-components';

export const Wrapper = styled.button`
  background-color: transparent !important;
  border: none;
  padding: 0px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: none !important;
  cursor: pointer;
  max-height: 27px;
`;
